<template>
  <!-- [matrah] legacy: single v-snackbar (one message at a time, replaced by the next one)
  <v-snackbar :color="alertMessage?.class" v-if=getAlertMessageDisplay v-model="snackbar" location="top right" :timeout="alertMessage?.timeout">
    {{ alertMessage?.text }}
    <template v-slot:actions>
      <v-btn color="red" variant="text" @click="snackbar = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
  -->
  <!-- [matrah] stacked toasts: success green / error red / warning amber / info blue, auto-hide,
       newest at the bottom, RTL-friendly (logical properties + dir="auto" per message). -->
  <div class="matrah-toasts" aria-live="polite" aria-atomic="false">
    <transition-group name="matrah-toast">
      <div v-for="item in toasts" :key="item.id" class="matrah-toast" :class="`matrah-toast--${item.type}`"
        :role="item.type === 'error' ? 'alert' : 'status'">
        <v-icon class="matrah-toast__icon" size="22" :icon="icons[item.type] || icons.info"></v-icon>
        <div class="matrah-toast__text" dir="auto">{{ item.text }}</div>
        <button type="button" class="matrah-toast__close" aria-label="Close" @click="dismissToast(item.id)">
          <v-icon size="18" icon="mdi-close"></v-icon>
        </button>
        <span v-if="item.timeout > 0" class="matrah-toast__timer" :style="{ animationDuration: `${item.timeout}ms` }"></span>
      </div>
    </transition-group>
  </div>
</template>


<script>

import { mapState, mapActions } from 'pinia'

import { useGlobalStore } from '../../stores/global'


export default {
  name: "notification-component",
  data: () => ({
      // snackbar: false,
      text: 'My timeout is set to 2000.',
      timeout: 2000,
      // [matrah]
      icons: {
        success: 'mdi-check-circle',
        error: 'mdi-alert-circle',
        warning: 'mdi-alert',
        info: 'mdi-information',
      },
    }),
  computed: {
    // [matrah] legacy: ...mapState( useGlobalStore , [ 'alertMessage', 'getAlertMessageDisplay']),
    ...mapState(useGlobalStore, ['toasts']),
    // [matrah] legacy:
    // snackbar: {
    //   get() {
    //     console.log("get ",  this.alertMessage.display)
    //     return this.alertMessage.display;
    //   },
    //   set() {
    //     let alertMessage = this.alertMessage;
    //     alertMessage.display = false
    //     this.setAlertMessage(alertMessage);
    //   }
    // }
  },
  methods: {
    // [matrah] legacy: ...mapActions(useGlobalStore, ['setAlertMessage']),
    ...mapActions(useGlobalStore, ['setAlertMessage', 'dismissToast']),
  }
};
</script>

<style scoped>
/* top-centre, just under the app bar: never covers the conversation header actions (right)
   or the composer / Send button (bottom); symmetric for RTL. */
.matrah-toasts {
  position: fixed;
  top: 68px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: min(440px, calc(100vw - 32px));
  pointer-events: none;
}

.matrah-toast {
  position: relative;
  overflow: hidden;
  pointer-events: auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 12px 14px;
  border-radius: 10px;
  color: #fff;
  box-shadow: 0 8px 24px rgba(16, 38, 26, 0.18), 0 2px 6px rgba(16, 38, 26, 0.12);
  font-size: 14px;
  line-height: 1.45;
}

.matrah-toast--success { background: #2E7D32; }
.matrah-toast--error { background: #C62828; }
.matrah-toast--warning { background: #B7791F; }
.matrah-toast--info { background: #1E6FA8; }

.matrah-toast__icon {
  flex: 0 0 auto;
  margin-top: 1px;
  color: #fff;
}

.matrah-toast__text {
  flex: 1 1 auto;
  min-width: 0;
  white-space: pre-line;
  overflow-wrap: anywhere;
  text-align: start;
  font-weight: 500;
}

.matrah-toast__close {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: #fff;
  opacity: 0.8;
  background: transparent;
  cursor: pointer;
}

.matrah-toast__close:hover,
.matrah-toast__close:focus-visible {
  opacity: 1;
  background: rgba(255, 255, 255, 0.18);
  outline: none;
}

.matrah-toast__timer {
  position: absolute;
  inset-inline-start: 0;
  bottom: 0;
  height: 3px;
  width: 100%;
  background: rgba(255, 255, 255, 0.45);
  transform-origin: left center;
  animation-name: matrah-toast-timer;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

[dir='rtl'] .matrah-toast__timer {
  transform-origin: right center;
}

@keyframes matrah-toast-timer {
  from { transform: scaleX(1); }
  to { transform: scaleX(0); }
}

.matrah-toast-enter-active,
.matrah-toast-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.matrah-toast-enter-from,
.matrah-toast-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.matrah-toast-move {
  transition: transform 0.22s ease;
}

@media (prefers-reduced-motion: reduce) {
  .matrah-toast-enter-active,
  .matrah-toast-leave-active,
  .matrah-toast-move {
    transition: none;
  }
  .matrah-toast__timer {
    animation: none;
    display: none;
  }
}
</style>
